import React, { useEffect, useState } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import "./LeftSidebar.css";
import GlobalPostButton from "./GlobalPostButton";

const LeftSidebar = ({ userThumbnail, userName }) => {
  const [hasNewAlerts, setHasNewAlerts] = useState(false);
  const [showAiPremiumModal, setShowAiPremiumModal] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const checkForNewAlerts = () => {
      const currentUser = JSON.parse(localStorage.getItem("currentUser"));
      if (!currentUser) return;

      const userId = currentUser.id;

      const lastSeenUser = localStorage.getItem(`lastSeenUserAlerts_${userId}`);
      const lastSeenSystem = localStorage.getItem(`lastSeenSystemNotices_${userId}`);
      const latestUser = localStorage.getItem("latestUserAlert");
      const latestSystem = localStorage.getItem("latestSystemNotice");

      console.log("🧠 Stored times:");
      console.log("🕒 latestUser:", latestUser);
      console.log("🕒 lastSeenUser:", lastSeenUser);
      console.log("🕒 latestSystem:", latestSystem);
      console.log("🕒 lastSeenSystem:", lastSeenSystem);

      const newUser =
        latestUser &&
        new Date(latestUser).toString() !== "Invalid Date" &&
        (!lastSeenUser || new Date(latestUser) > new Date(lastSeenUser));

      const newSystem =
        latestSystem &&
        new Date(latestSystem).toString() !== "Invalid Date" &&
        (!lastSeenSystem || new Date(latestSystem) > new Date(lastSeenSystem));

      console.log("🔍 New user alerts?", newUser);
      console.log("🔍 New system notices?", newSystem);

      setHasNewAlerts(newUser || newSystem);
    };

    checkForNewAlerts();

    const handleVisibility = () => {
      if (!document.hidden) {
        checkForNewAlerts();
      }
    };

    const intervalId = setInterval(checkForNewAlerts, 5000);
    document.addEventListener("visibilitychange", handleVisibility);

    return () => {
      clearInterval(intervalId);
      document.removeEventListener("visibilitychange", handleVisibility);
    };
  }, []);

  const handleLogout = async () => {
    try {
      await fetch("/backend/logout", {
        method: "POST",
        credentials: "include",
      });
    } catch (error) {
      console.error("Server logout request failed:", error);
    } finally {
      localStorage.removeItem("currentUser");
      alert("You have been logged out.");
      window.location.href = "/login";
    }
  };

  const handleSearchClick = (e) => {
    e.preventDefault();

    setTimeout(() => {
      let searchInput = null;

      if (window.location.pathname.startsWith("/notifications")) {
        searchInput = document.querySelector(".notifications-search-box");
      } else if (window.location.pathname.startsWith("/communities")) {
        searchInput = document.querySelector(".communities-search-box");
      } else if (window.location.pathname === "/") {
        searchInput = document.querySelector(".home-search-box");
      } else if (window.location.pathname.startsWith("/profile")) {
        searchInput = document.querySelector(".profile-search-box");
      } else if (window.location.pathname.startsWith("/cloud9")) {
        searchInput = document.querySelector(".cloud9-search-box");
      } else if (window.location.pathname.startsWith("/settings")) {
        searchInput = document.querySelector(".settings-search-box");
      } else if (window.location.pathname.startsWith("/help")) {
        searchInput = document.querySelector(".help-search-box");
      } else {
        searchInput = document.querySelector(".search-box");
      }

      if (searchInput) {
        searchInput.focus();
        searchInput.click();
        searchInput.select();
      }
    }, 100);
  };

  const handleAskScoldyClick = (e) => {
    let currentUser = null;
    try {
      currentUser = JSON.parse(localStorage.getItem("currentUser"));
    } catch {
      currentUser = null;
    }

    if (![6, 7, 8, 9].includes(Number(currentUser?.group_id))) {
      e.preventDefault();
      setShowAiPremiumModal(true);
    }
  };

  const handleHomeClick = (e) => {
    if (location.pathname === "/") {
      e.preventDefault();
      window.dispatchEvent(new CustomEvent("resetHomeToTop"));
      return;
    }
  };

  const handleCommunitiesClick = (e) => {
    if (location.pathname.startsWith("/communities")) {
      e.preventDefault();
      window.dispatchEvent(new CustomEvent("resetCommunitiesToGeneral"));
      return;
    }

    navigate("/communities");
  };

  return (
    <nav className="left-sidebar">
      <h3>Navigation</h3>
      <ul>
        <li>
          <NavLink to="/" onClick={handleHomeClick}>
            <span className="sidebar-icon">🏠</span> Home
          </NavLink>
        </li>
        <li>
          <NavLink to="/communities" onClick={handleCommunitiesClick}>
            <span className="sidebar-icon">👥</span> Communities
          </NavLink>
        </li>
        <li>
          <NavLink to="/profile">
            <span className="sidebar-icon">👤</span> Profile
          </NavLink>
        </li>
        <li>
          <NavLink to="/notifications">
            <span className="sidebar-icon">🔔</span> Notifications
            {hasNewAlerts && <span className="dot-indicator sidebar-dot" />}
          </NavLink>
        </li>
        <li>
          <NavLink to="/settings">
            <span className="sidebar-icon">⚙️</span> Settings
          </NavLink>
        </li>
        <li>
          <NavLink to="/cloud9">
            <span className="sidebar-icon">☁️</span> Premium
          </NavLink>
        </li>
        <li>
          <NavLink to="/ask-scoldy" onClick={handleAskScoldyClick}>
            <span className="sidebar-icon">✦</span> Ask Scoldy AI
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/help"
            onClick={() => {
              if (window.location.pathname.startsWith("/help")) {
                window.dispatchEvent(new Event("resetHelpHome"));
              }
            }}
          >
            <span className="sidebar-icon">❓</span> Help
          </NavLink>
        </li>
        <li>
          <a href="#" onClick={handleSearchClick}>
            <span className="sidebar-icon">🔍</span> Search
          </a>
        </li>
        <li>
          <button onClick={handleLogout} className="logout-button">
            <span className="sidebar-icon">🚪</span> Logout
          </button>
        </li>
      </ul>

      <div className="global-post-button-container">
        <GlobalPostButton />
      </div>

      <div className="user-info-container">
        <img
          src={
            userThumbnail?.startsWith("http")
              ? userThumbnail
              : `${process.env.REACT_APP_API_URL}/${userThumbnail}`
          }
          alt={userName || "User"}
          className="sidebar-user-thumbnail"
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = "/images/default-thumbnail.jpg";
          }}
        />

        <span className="sidebar-user-text">Logged in as: {userName || "User"}</span>
      </div>
      {showAiPremiumModal && (
        <div className="ai-premium-modal-backdrop" onMouseDown={() => setShowAiPremiumModal(false)}>
          <div className="ai-premium-modal" role="dialog" aria-modal="true" aria-labelledby="ai-premium-modal-title" onMouseDown={(e) => e.stopPropagation()}>
            <button type="button" className="ai-premium-modal-close" aria-label="Close" onClick={() => setShowAiPremiumModal(false)}>×</button>
            <div className="ai-premium-modal-mark">✦</div>
            <h2 id="ai-premium-modal-title">Ask Scoldy AI</h2>
            <p>Ask Scoldy AI and Scoldy AI Research are included with Scoldy Premium plans.</p>
            <div className="ai-premium-modal-actions">
              <button type="button" className="ai-premium-modal-primary" onClick={() => { setShowAiPremiumModal(false); navigate("/cloud9"); }}>View Premium Plans</button>
              <button type="button" className="ai-premium-modal-secondary" onClick={() => setShowAiPremiumModal(false)}>Not Now</button>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
};

export default LeftSidebar;